import { Box } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'

const AuditResultCard = ({
    ip,
    totalObservations,
    totalNewErrors,
    totalDuplicatesRemoved,
    totalUniqueErrors,
    totalIngoredErrors,
    totalCorrectedIdentified,
}) => {
    return (
        <Box>
            <Box
                sx={{
                    color: "black",
                    fontSize: "18px",
                }}
            >
                Total {ip} Observation(s): {totalObservations}
            </Box>

            <ul >
                {totalDuplicatesRemoved > 0 &&
                (<li>
                    <Box
                        sx={{
                            fontSize: "16px",
                        }}
                    >
                        Duplicate {totalDuplicatesRemoved == 1 ? "entry" : "entries"} Removed: {totalDuplicatesRemoved}
                    </Box>
                </li>
                )}

                {totalIngoredErrors > 0 && 
                (<li>
                    <Box
                        sx={{
                            fontSize: "16px",
                        }}
                    >
                        System-ignored {totalIngoredErrors == 1 ? "item":  "items"} moved to Archived: {totalIngoredErrors} 
                    </Box>
                </li>
                )}
            </ul>

            {totalNewErrors > 0 &&
            (<Box sx={{
                backgroundColor: "rgba(0,0,0,0.03)",
                padding: "20px"
            }}>
                <Box
                    sx={{
                        fontSize: "18px",
                        color: "black"
                    }}
                >
                    {totalNewErrors == 1 ? "Observation" : "Observations"} requiring attention: {totalNewErrors}
                </Box>
                <hr style={{ width: "100%" , border: "1.2px solid black" }} />

                {totalUniqueErrors > 0 &&
                (<Box
                    sx={{
                        fontSize: "18px",
                        color: "#008ad5"
                    }}
                >
                    Unique {totalUniqueErrors == 1 ? "observation" : "observations"}: {totalUniqueErrors}
                </Box>
                )}
                {totalCorrectedIdentified > 0 &&
                (<Box sx={{ fontSize: "18px", color: "#008ad5" }}>
                    Corrected {totalCorrectedIdentified == 1 ? "observation" : "observations"} reappeared: {totalCorrectedIdentified}
                </Box>
                )}
            </Box>
            )}
        </Box>
    )
}
AuditResultCard.propTypes = {
  ip: PropTypes.string.isRequired,
  totalObservations: PropTypes.number.isRequired,
  totalNewErrors: PropTypes.number.isRequired,
  totalDuplicatesRemoved: PropTypes.number.isRequired,
  totalUniqueErrors: PropTypes.number.isRequired,
  totalIngoredErrors: PropTypes.number.isRequired,
  totalCorrectedIdentified: PropTypes.number.isRequired,
};

export default AuditResultCard